/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

// Action types helper functions

export function createTypesMap(context, types) {
  const typesMap = {};
  types.forEach((type) => {
    typesMap[type] = `${context}.${type}`;
  });
  return typesMap;
}




// WEBPACK FOOTER //
// ./src/redux/actions/types.js